module.exports = __webpack_public_path__ + "img/czbg.8e906651.png";